export default "__VITE_ASSET__B3Kr5QQM__"